import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: () => import(/* webpackChunkName: "dashboard" */ './ui/views/Dashboard.vue'),
    },
    {
      path: '/metrics',
      component: () => import(/* webpackChunkName: "metrics" */ './ui/views/Metrics.vue'),
    },
    {
      path: '/parking_lot/:id',
      component: () => import(/* webpackChunkName: "parking_lot_detail" */ './ui/views/ParkingLotDetail.vue'),
      children: [
        {
          path: ':mode',
          component: () => import(/* webpackChunkName: "parking_lot_detail" */ './ui/views/ParkingLotDetail.vue'),
        },
      ],
    },
    {
      path: '/parking_lot_metrics/:id',
      component: () => import(/* webpackChunkName: "parking_lot_metrics" */ './ui/views/ParkingLotMetrics.vue'),
      children: [
        {
          path: ':mode',
          component: () => import(/* webpackChunkName: "parking_lot_detail" */ './ui/views/ParkingLotMetrics.vue'),
        },
      ],
    },
  ],
});
